import 'antd/dist/antd.variable.min.css';
import { ConfigProvider, Layout, Spin } from 'antd';
import { useLeadService } from './context/lead-service.context';
import React, { useEffect } from 'react';
import { SignUpSteps } from './components/sign-up-steps';
import { Route, Routes } from 'react-router-dom';
import { useTrackingCode } from "react-hubspot-tracking-code-hook";
import { ConfirmationPage } from './components/confirmation';
import { LowFundingPage } from "./components/low-funding";
import { useResponsive } from "./utils/use-responsive";
import { Error404 } from "./components/error-404";
import { datadogRum } from '@datadog/browser-rum';
import { ForgotPassword } from "./components/auth/forgot-password";
import { CreateAccountPage } from "./components/auth/create-account";
import { LoginPage } from "./components/auth/login";
import { ForgotPasswordResetPage } from "./components/auth/forgot-password-reset";
import { ThankYouCodat } from './components/thank-you-codat';
import { Dashboard } from "./components/dashboard/dashboard";
import Cookies from "universal-cookie";
import { useDocuments } from "./context/documents.context";


ConfigProvider.config({
  theme: {
    primaryColor: '#072E3D',
  },
});

export function App() {
  const { loading } = useLeadService();
  const { documentLoading } = useDocuments();
  const { isXs } = useResponsive();
  const { setTrackPageView } = useTrackingCode();

  const applicationIdEnv = process.env['REACT_APP_APPLICATION_ID'];
  const clientTokenEnv = process.env['REACT_APP_CLIENT_TOKEN'];
  const cookies = new Cookies();
  const refreshToken = cookies.get('jwt_authorization');

  //const isPrivateRouteAllowed = !!refreshToken;

  setTrackPageView();

  useEffect(() => {
    if (applicationIdEnv !== undefined && applicationIdEnv !== '' &&
      clientTokenEnv !== undefined && clientTokenEnv !== '') {
      datadogRum.init({
        applicationId: applicationIdEnv || '',
        clientToken: clientTokenEnv || '',
        site: 'datadoghq.eu',
        service: 'financefair-sign-up',
        env: 'production',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
      });
    }
  }, [applicationIdEnv, clientTokenEnv]);

  return (
    <ConfigProvider>
      <Spin
        size={'large'}
        tip="Loading..."
        className={'full-width'}
        spinning={loading || documentLoading}
      >
        <Layout style={isXs ? { backgroundColor: "white" } : undefined}>
          <Routes>
            <Route
              path="/"
              element={
                <SignUpSteps/>
              }
            />

            <Route
              path="/connect-open-banking"
              element={
                <ConfirmationPage/>
              }
            />
            <Route
              path="/low-funding"
              element={
                <LowFundingPage/>
              }
            />
            <Route
              path="/create-account"
              element={
                <CreateAccountPage/>
              }
            />
            <Route
              path="/login"
              element={
                <LoginPage/>
              }
            />
            <Route
              path="/thank-you"
              element={<ThankYouCodat/>}
            />

            <Route path="/forgot-password"
                   element={
                     <ForgotPassword/>
                   }
            />
            <Route
              path="/reset-password"
              element={
                <ForgotPasswordResetPage/>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Dashboard/>
              }
            />
            <Route
              path="*"
              element={<Error404></Error404>}
            />
          </Routes>
        </Layout>
      </Spin>
    </ConfigProvider>
  );
}

export default App;
